export const HelpTextDefaultProps = {
  isError: false
};